module.exports = __webpack_public_path__ + "img/lauryn-signature.78007bd8.png";